import Modal from './Modal';
import Html5QrcodePlugin from '../../../screens/Diagnostics/Html5QrcodePlugin';
import classes from './QrCodeModal.module.css';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSuccessScan: any;
};

const QrCodeModal: React.FC<Props> = ({ isOpen, onClose, onSuccessScan }) => {
  const { translations } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} header={translations('scan.qr.code')}>
      <div className={classes.container}>
        {isOpen && (
          <div className={classes.scanContainer}>
            <Html5QrcodePlugin
              className={classes.scan}
              fps={10}
              qrbox={250}
              disableFlip={false}
              qrCodeSuccessCallback={(decodedText: any, decodedResult: any) => {
                onSuccessScan(decodedText, decodedResult);
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default QrCodeModal;
